import React from 'react';
import { useSessionManager } from '../hooks/useSessionManager';
import { useAuthStore } from '../features/auth/authStore';
import { SessionWarningModal } from './SessionWarningModal';

export const SessionManager: React.FC = () => {
  const { logout, isLoading } = useAuthStore();
  const {
    sessionInfo,
    showWarning,
    handleWarningClose,
    handleWarningExtend
  } = useSessionManager();

  // Don't render anything while auth is still loading
  if (isLoading) {
    return null;
  }

  const handleLogout = () => {
    logout();
  };

  return (
    <SessionWarningModal
      isOpen={showWarning}
      onClose={handleWarningClose}
      onExtend={handleWarningExtend}
      onLogout={handleLogout}
      timeLeft={sessionInfo.timeUntilExpiry || 0}
    />
  );
};

export default SessionManager;
